import server from "./server";

export const getObjectionsApi = async () => {
  const response = await server().get("/objectionRequests");
  return response.data;
};

export const getSingleObjectionApi = async (id) => {
  const response = await server().get(`/objectionRequests/${id}`);
  return response.data;
};

export const deleteObjectionApi = async ({ id }) => {
  const response = await server().delete(`/objectionRequests/${id}`);
  return response.data;
};
